import {Dispatch, SetStateAction} from 'react';

interface Props {
  title: string;
  rightIcon?: string;
  rightIconHandler?: () => void;
  infoBtn?: boolean;
  leftIcon?: string;
  leftIconHandler?: () => void;
  leftIconBack?: boolean;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
  customClassName?: string;
  stickToTop?: boolean;
}

const AppHeaderBar = ({
  title,
  rightIcon,
  rightIconHandler,
  infoBtn,
  leftIcon,
  leftIconHandler,
  setIsOpen,
  customClassName,
  stickToTop,
}: Props) => {
  return (
    <div
      className={`w-full h-14 px-6 flex items-center justify-between bg-white drop-shadow z-[10] ${customClassName} ${
        stickToTop && 'fixed top-0 left-0 right-0'
      }`}
    >
      <div className="flex items-center gap-1">
        {rightIcon && (
          <i
            className={`${rightIcon} ml-1 text-2xl text-gray-900`}
            onClick={rightIconHandler}
          />
        )}
        <span className="text-md text-gray-900 font-medium">{title}</span>
        {infoBtn && (
          <i
            className="icon-size2489 text-green-500"
            onClick={() => setIsOpen && setIsOpen(prev => !prev)}
          />
        )}
      </div>
      {leftIcon && (
        <i
          className={`${leftIcon} text-2xl text-gray-900`}
          onClick={leftIconHandler}
        />
      )}
    </div>
  );
};

export default AppHeaderBar;
